(function($) {

    if($(".slick_slider").length > 0){  
      $(".slick_slider").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        speed: 4000,
        autoplay: true,
        autoplaySpeed: 0,
        pauseOnHover: false,
        pauseOnFocus: false,
        cssEase: 'linear',
        useCSS: true,
        useTransform: true,
        responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 5000,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 6800,
          }
        }
      ]
      });
    }
  

})(jQuery);